var map = {
	"./angle": 21,
	"./angle.svg": 21,
	"./auth-bg": 22,
	"./auth-bg.png": 22,
	"./comments": 23,
	"./comments.svg": 23,
	"./course-1": 24,
	"./course-1.png": 24,
	"./course-2": 25,
	"./course-2.png": 25,
	"./courses-logo": 26,
	"./courses-logo.svg": 26,
	"./courses-logo2": 27,
	"./courses-logo2.svg": 27,
	"./delete": 28,
	"./delete.gif": 28,
	"./google": 29,
	"./google.png": 29,
	"./logo": 30,
	"./logo.svg": 30,
	"./star": 19,
	"./star.gif": 35,
	"./star.png": 19,
	"./user": 31,
	"./user.png": 31
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 34;